import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useWarehousesList() {

    // Use toast
    const toast = useToast();

    const refWarehouseListTable = ref(null);

    // Table Handlers
    let tableColumns = [
        { key: 'alias', sortable: true, label: 'ALIAS' },
        { key: 'address', sortable: false, label: 'DIRECCIÓN' },
        { key: 'phone', sortable: false, label: 'TELÉFONO' },
        { key: 'priority', sortable: false, label: 'ORDEN' },
        { key: 'allows_pickup', sortable: false, label: 'RECOJO' },
        { key: 'is_active', sortable: true, label: 'ESTADO' },
        { key: 'actions', label: 'ACCIONES' }
    ];

    const perPage = ref(10);
    const totalWarehouses = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('priority');
    const isSortDirDesc = ref(false);

    // Extra Filters
    const statesFilter = ref(null);

    const dataMeta = computed(() => {
        const localItemsCount = refWarehouseListTable.value ? refWarehouseListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalWarehouses.value,
        }
    });

    const refetchData = () => {
        refWarehouseListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery, statesFilter], () => {
        refetchData();
    });

    const fetchWarehouses = (ctx, callback) => {
        store
            .dispatch('app-warehouse/fetchWarehouses', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                states: statesFilter.value
            })
            .then(response => {
                const { warehouses, total } = response.data;
                callback(warehouses);
                totalWarehouses.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista de almacenes',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            })
    };

    return {
        fetchWarehouses,
        tableColumns,
        perPage,
        currentPage,
        totalWarehouses,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refWarehouseListTable,
        refetchData,

        // Extra Filters
        statesFilter
    }
}
